module.exports = __webpack_public_path__ + "static/media/bg_dishdirt.b75d4476.jpg";